import { Backdrop, Box, CircularProgress, Modal, TextareaAutosize, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LeftArrow from '../../../../../../asset/svg/leftArrow.svg';
import '../../../../../../scss/pages/Attendance/Component/Asset/Assets/Asset Infos/assetInfo.scss';
import { DE_REGISTERED_ASSET_PATH } from '../../../../../../utils/Constants';
import { generateRandomId } from '../../../../../../components/common/GenerateRandomId/GenerateRandomId';
import { DELETE_UPLOADFILE_DE_REGISTER, DE_REGISTER_ASSET_LIST, GET_AGREEMENT_UPLOADFILE_OBJECT_DATA, GET_ASSET_UPLOADFILE_OBJECT_DATA } from '../../../../../../sagas/type';
import { getLocalStoreString } from '../../../../../../utils/Helper';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

function AssetInfo() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const { SelectedAssetInfoDeRegister, CheckIsiOSDevice } = useSelector(mapStateToProps);
    const [newFormData, setNewFormData] = useState([]);
    const [selectAssetCondition, setSelectAssetCondition] = useState(false)
    const EmployeeCode = getLocalStoreString("EmployeeCode");
    const assetConditionStatus = [{ id: 1, status: 'Working condition' }, { id: 2, status: 'Damaged' }]
    const [selectOptionStatus, setSelectOptionStatus] = useState('')
    const [objId, setObjId] = useState()
    const [uploadPhotos, setUploadPhotos] = useState([])
    const [loader, setLoader] = useState(false)
    const [remarks, setRemarks] = useState('')
    const [cameraModalOpen, setCameraModalOpen] = useState(false);
    const [facingMode, setFacingMode] = useState('user');

    const handleSelectAssetCondition = () => {
        setSelectAssetCondition(true)
    }
    const handleSelectAssetConditionOption = (item) => {
        setSelectAssetCondition(false)
        setSelectOptionStatus(item)
    }

    const handleBack = () => {
        navigate(DE_REGISTERED_ASSET_PATH)
    }

    const handleRemarks = (e) => {
        setRemarks(e.target.value);
    }

    const handleFileDelete = (id) => {
        dispatch({
            type: DELETE_UPLOADFILE_DE_REGISTER,
            payload: { employeeCode: EmployeeCode, objectId: id?.id },
            setUploadPhotos: setUploadPhotos,
        })
        const uploadData = [...uploadPhotos]
        const filterData = uploadData.filter((item) => item.id !== id?.id)
        setUploadPhotos(filterData);
    }

    const renderFileUploadFile = (fileObj, index) => {
        if (fileObj) {
            return (
                <div key={index} style={{ width: "130px", height: "175px", borderRadius: "16px" }}>
                    <img src={fileObj?.filePath} alt='imageFile' style={{ width: "100%", height: "100%", objectFit: "fill", borderRadius: "16px" }} />
                </div>
            );
        }
    }

    const isFormValid = () => {
        return (
            selectOptionStatus &&
            uploadPhotos.length > 0 &&
            remarks.trim() !== ''
        );
    };

    const handleProceed = () => {
        const randomId = generateRandomId(8)
        const UplaodPhotosData = uploadPhotos?.map((item) => { return { objectId: item.id } })
        const assetData = {
            assetName: SelectedAssetInfoDeRegister[0]?.name,
            assetId: SelectedAssetInfoDeRegister[0]?.code,
            assetCondition: selectOptionStatus,
            id: SelectedAssetInfoDeRegister[0]?.id,
            remarks: remarks,
            uploads: UplaodPhotosData,
            randomId: randomId,
            purchaseId: SelectedAssetInfoDeRegister[0]?.purchaseId,
        };
        const isDuplicate = newFormData.some((existingData) => {
            return (
                existingData.assetName === assetData.assetName &&
                existingData.assetId === assetData.assetId &&
                existingData.assetCondition === assetData.assetCondition &&
                existingData.remarks === assetData.remarks
            );
        });

        if (!isDuplicate) {
            setNewFormData((prevData) => [...prevData, assetData]);
            dispatch({
                type: DE_REGISTER_ASSET_LIST,
                payload: [...newFormData, assetData],
                navigate: navigate,
            });
        } else if (isDuplicate) {
            enqueueSnackbar('Data already exists in the array', { variant: 'error' });
        }
    }

    const handleClose = (event, reason) => {
        if (reason !== "backdropClick") {
            setOpen(false);
        }
    };

    const switchCamera = () => {
        setFacingMode(prevMode => (prevMode === 'user' ? 'environment' : 'user'));
    };

    const capture = (dataUri) => {
        if (dataUri) { setLoader(true) }
        if (CheckIsiOSDevice == 'iOS') {
            const file = dataUri.target.files[0];
            const uploadFile = {
                file,
                randomId: generateRandomId(10),
            };
            dispatch({
                type: GET_ASSET_UPLOADFILE_OBJECT_DATA,
                payload: { employeeCode: EmployeeCode, uploadFile: uploadFile.file },
                setObjId: setObjId,
                setUploadPhotos: setUploadPhotos,
                setLoader: setLoader,
                enqueueSnackbar: enqueueSnackbar,
            });
            setCameraModalOpen(false);
        } else {
            const randomId = generateRandomId(10)
            const blob = dataURItoBlob(dataUri);
            const file = new File([blob], `captured-image-${Date.now()}.jpg`, { type: 'image/jpeg' });
            const uploadFile = {
                file,
                randomId
            }
            dispatch({
                type: GET_ASSET_UPLOADFILE_OBJECT_DATA,
                payload: { employeeCode: EmployeeCode, uploadFile: uploadFile.file },
                setObjId: setObjId,
                setUploadPhotos: setUploadPhotos,
                setLoader: setLoader,
                enqueueSnackbar: enqueueSnackbar,
            })
            setCameraModalOpen(false);
        }
    };

    const dataURItoBlob = (dataURI) => {
        const byteString = atob(dataURI.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: 'image/jpeg' });
    };

    return (
        <>
            <div className='Asset-Info-Container' >
                <div className='Asset-Info-Container_header'>
                    <div className='Asset-Info-Container_head-height '>
                        <img className='Asset-Info-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                        <span className='Asset-Info-Container_header_content'>Asset Info</span>
                    </div>
                </div>
                <div className='Asset-Info-Container_Overflow-Container'>
                    {SelectedAssetInfoDeRegister.length > 0 && SelectedAssetInfoDeRegister.map((item) => {
                        return (
                            <div key={item?.id} className='Asset-Info-Container_card-Parent-Container'>
                                <div className="Asset-Info-Container_card-Heading">
                                    <div className='Asset-Info-Container_card-Heading_child' >
                                        <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '11px' }}>Assets Name</Typography>
                                        <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '14px', marginTop: "2px" }} value="name">{item?.name}</Typography>
                                    </div>
                                </div>
                                <div className="Asset-Info-Container_card-Heading">
                                    <div className='Asset-Info-Container_card-Heading_child'>
                                        <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '11px' }}>Assets ID</Typography>
                                        <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '14px', marginTop: "2px" }} value="name">{item?.code}</Typography>
                                    </div>
                                </div>
                            </div>)
                    })}
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div className='Asset-Info-Container_Photo-Upload'>
                            <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: 400 }}>Add Photos {uploadPhotos.length > 0 ? `(${uploadPhotos.length})` : ''}</Typography>
                        </div>
                        {uploadPhotos?.length >= 2 && uploadPhotos?.length < 5 && <div className='Asset-Info-Container_Add-photo'>
                            {CheckIsiOSDevice == 'iOS' ?
                                <>
                                    <label htmlFor="imageFile" style={{ whiteSpace: "nowrap", color: "rgba(255, 255, 255, 0.40)", fontSize: "14px", fontWeight: 500 }}>
                                        <Typography sx={{ color: '#4B2EF1', fontSize: "12px" }}>Add Photo</Typography>
                                    </label>
                                    <input type="file" id="imageFile" capture="user" accept="image/*" onChange={capture} />
                                </>
                                :
                                <label onClick={() => setCameraModalOpen(true)}>
                                    <Typography sx={{ color: '#4B2EF1', fontSize: "12px" }}>Add Photo</Typography>
                                </label>
                            }
                        </div>}
                    </div>
                    <div style={{ display: "flex", gap: "15px", gridTemplateColumns: "auto auto", overflowX: "auto", overflowY: "hidden", width: "318px" }}>
                        {uploadPhotos?.length > 0 && uploadPhotos?.map((fileObj, index) => {
                            return (
                                <div key={fileObj?.id} className='Asset-Info-Container_Photo-copy-or'>
                                    <ClearIcon sx={{ width: "16px", height: "16px", color: "#FFF", opacity: "0.8", position: "absolute", top: 10, right: 10 }} onClick={() => handleFileDelete(fileObj)} />
                                    <div
                                        //  onClick={() => handleViewPdfDocument(fileObj?.url, "", fileObj?.file?.type)}
                                        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        {renderFileUploadFile(fileObj, index)}
                                    </div>
                                </div>
                            )
                        })}
                        {uploadPhotos?.length > 0 && uploadPhotos?.length < 2 && (
                            <div className='Asset-Info-Container_Photo-copy-or'>
                                {CheckIsiOSDevice == 'iOS' ?
                                    <>
                                        <label htmlFor="imageFile" style={{ whiteSpace: "nowrap", color: "rgba(255, 255, 255, 0.40)", fontSize: "14px", fontWeight: 500 }}>
                                            <AddIcon sx={{ width: "20px", height: "20px", color: "#FFF", opacity: "0.3" }} />
                                        </label>
                                        <input type="file" id="imageFile" capture="user" accept="image/*" onChange={capture} />
                                    </>
                                    :
                                    <button style={{ width: "130px", height: "175px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent', border: "none" }} onClick={() => setCameraModalOpen(true)}>
                                        <AddIcon sx={{ width: "20px", height: "20px", color: "#FFF", opacity: "0.3" }} />
                                    </button>
                                }
                            </div>
                        )}
                    </div>
                    {!uploadPhotos.length && <div className='Asset-Info-Container_Photo-copy'>
                        {CheckIsiOSDevice == 'iOS' &&
                            <div className='Asset-Info-Container_Photo-copy-child'>
                                <CameraAltIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '13px', width: '13px' }} />
                                <label htmlFor="imageFile" style={{ whiteSpace: "nowrap", color: "rgba(255, 255, 255, 0.40)", fontSize: "14px", fontWeight: 500 }}>Upload a Photo</label>
                                <input type="file" id="imageFile" capture="user" accept="image/*" onChange={capture} />
                            </div>}
                        {CheckIsiOSDevice !== 'iOS' &&
                            <div className='Asset-Info-Container_Photo-copy-child'>
                                <button style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: 'transparent', border: "none" }} onClick={() => setCameraModalOpen(true)}>
                                    <CameraAltIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '13px', width: '13px' }} />
                                    <Typography sx={{ whiteSpace: "nowrap", color: "rgba(255, 255, 255, 0.40)", fontSize: "14px", fontWeight: 500 }}>Upload a Photo</Typography>
                                </button>
                            </div>
                        }

                    </div>}
                    <Modal
                        open={cameraModalOpen}
                        onClose={handleClose}
                        aria-labelledby="camera-modal-title"
                        aria-describedby="camera-modal-description"
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", backgroundColor: "rgb(0.0.0.1)" }}
                    >
                        <div className='Asset-Info-Container_camera-modal'>
                            <Camera
                                onTakePhoto={(dataUri) => capture(dataUri)}
                                onCameraError={(error) => console.error('Camera error', error)}
                                idealFacingMode={facingMode}
                                isFullscreen={true}
                                isImageMirror={false}
                                isSilentMode={true}
                                isDisplayStartCameraError={false}
                                sizeFactor={1}
                            />
                            <div style={{ display: "flex", position: "absolute", bottom: "20px", width: "100%", justifyContent: "space-around", alignItems: "center" }} className='Asset-Info-Container_registerData_buttonContainer'>
                                <HighlightOffIcon className='Asset-Info-Container_registerData_buttonContainer_active-button-camera' sx={{ width: "25px", height: "25px", color: "#FFF", left: 2 }} onClick={() => setCameraModalOpen(false)} />
                                <FlipCameraIosIcon className='Asset-Info-Container_registerData_buttonContainer_active-button-camera' sx={{ width: "25px", height: "25px", color: "#FFF", right: 2 }} onClick={switchCamera} />
                            </div>
                        </div>
                    </Modal>
                    <div className='Asset-Info-Container_Asset-condition'>
                        <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: 400 }}>Asset Condition</Typography>
                    </div>
                    <div className='Asset-Info-Container_Asset-Condition-Select' onClick={handleSelectAssetCondition}>
                        <Typography sx={{ fontSize: "12px", color: "#FFF", fontWeight: 400 }}>{selectOptionStatus ? selectOptionStatus : 'Select'}</Typography>
                        <KeyboardArrowDownIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '16px', width: '16px' }} />
                    </div>
                    <Modal
                        open={selectAssetCondition}
                        onClose={() => setSelectAssetCondition(false)}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%" }}
                    >
                        <div className='Asset-Info-Container_asset-condition-modal'>
                            <Box sx={{ backgroundColor: '#0B245F', borderRadius: '1rem', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', padding: "2% 4%" }}>
                                {assetConditionStatus.map((item) => {
                                    return (
                                        <Box key={item?.id} sx={{ padding: "3% 0", borderBottom: "1px solid rgba(255, 255, 255, 0.08)", width: "100%" }} onClick={() => handleSelectAssetConditionOption(item?.status)}>
                                            <Typography sx={{ color: "#FFF", fontSize: "14px", fontWeight: 500, whiteSpace: "nowrap", width: "100%" }}>{item?.status}</Typography>
                                        </Box>
                                    )
                                })}
                            </Box>
                        </div>
                    </Modal>

                    <div className='Asset-Info-Container_Asset-condition'>
                        <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: 400 }}>Add Remarks</Typography>
                    </div>
                    <div className='Asset-Info-Container_Photo-copy-Remarks'>
                        <TextareaAutosize value={remarks} minLength={4} maxRows={4} placeholder="Type in here…" style={{ padding: '4%', overflow: "auto", width: "100%", height: "70px", fontSize: "12px", fontWeight: 400, borderRadius: "9px", backgroundColor: "transparent", border: "none", color: "#FFF", fontFamily: "'Noto Sans', sans-serif", resize: "none" }} onChange={handleRemarks} />
                    </div>

                </div>
                <div className='Asset-Info-Container_registerData_buttonContainer'>
                    <button type='submit' disabled={!isFormValid()} className='Asset-Info-Container_registerData_buttonContainer_active-button' onClick={handleProceed}>Proceed</button>
                </div>
            </div >
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        SelectedAssetInfoDeRegister: state?.attendanceConfig?.SelectedAssetInfoDeRegister,
        CheckIsiOSDevice: state?.attendanceConfig?.CheckIsiOSDevice,
    }
}

export default AssetInfo;